const initialState = {
    isOpen: false,
    isActive: false,
    glat: 29.637926381354315,
    glng: 52.52513620990836,
    currentLocGlat: null,
    currentLocGlng: null,
};
const modalAddAddress = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_ADD_ADDRESS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalAddAddress;
